<template>
  <v-container fluid grid-list-md class="pa-0">
    <v-layout row wrap align-center class="scroll-y" style="height:52vh;">
      <!--<span class="f-20 textColor font-weight-bold">Create New Student</span>-->
      <v-flex xs12 lg12>
        <div class="f-15 textColor w-100 text-xs-left font-weight-bold">Personal info</div>
      </v-flex>
        <v-flex xs12 lg4>
        <v-text-field
          required

          color="#749DBF"
          type="text"
          placeholder="First Name"
          class="textFeald"
          solo
          label="First Name"
          :rules="requiredRule"
          v-model="user.firstName"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 lg4>
        <v-text-field
          required
          color="#749DBF"
          type="text"
          placeholder="Last Name"
          class="textFeald"
          solo
          label="Last Name"
          :rules="requiredRule"
          v-model="user.lastName"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 lg4>
        <v-text-field
          required
          color="#749DBF"
          class="textFeald"
          maxlength="8"
          solo
          prefix="+45"
          label="Phone Number"
          placeholder="Phone Number"
          :rules="[ v => v.length >= 8 || 'Required & It is 8 digits number']"
          v-model="user.phone"
        ></v-text-field>
      </v-flex>
      <!-- <v-flex xs12 lg4>
      <v-text-field
        required
        color="#749DBF"
        class="textFeald date"
        type="date"
        solo
        v-model="birthday"
      ></v-text-field>
      </v-flex>-->
      <!-- <v-flex xs12 lg4>
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="user.dob"
            lazy
            transition="scale-transition"
            persistent
            full-width
            min-width="290px"
          >
            <v-text-field
              placeholder="Birthday"
              solo
              required
              slot="activator"
              v-model="user.dob"
              hint="You can select age from 16 to 90 years"
              label="Birthday"
              readonly
            ></v-text-field>
            <v-date-picker
              :max="this.$root.getDaisableDate(16)"
              :min="this.$root.getDaisableDate(90)"
             v-model="user.dob" no-title scrollable >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.menu.save(user.dob)">OK</v-btn>
            </v-date-picker>
          </v-menu>
      </v-flex> -->

      <v-flex xs12 lg6 class="mb-3">
        <v-flex xs12 class="white shadow-1">
          <div class="f-9 pl-1 w-100 text-xs-left textColor font-weight-bold">Personal info</div>

          <div class="ma-0 pt-1 pl-2 white w-100">
            <date-dropdown
              :max="this.$root.getDaisableDate(16)"
              :min="this.$root.getDaisableDate(90)"
              v-model="user.dob" />
          </div>

        </v-flex>
      </v-flex>

      <v-flex xs12 lg6 class="mb-3">
        <v-flex xs12 class="white shadow-1">
          <div slot="label-top" class="active ml-2 text-xs-left w-100 text-primary f-9 pt-2">Address</div>
          <vue-dawa
            @select="selectItem($event, 'newUserAddr')"
            :val="newUserAddr.oneLineAddress"
            :showMax="5"
            containerId="stdAddresss_container"
            fieldId="stdAddresss_id"
            placeholder="Address"
            fieldName="stdAddresss_name"
          ></vue-dawa>
        </v-flex>
      </v-flex>

      <v-flex xs12 lg6 offset-xs0 class="mb-3">
        <v-flex xs12 class="shadow-1 white">
          <div class=" ml-2 f-12 text-xs-left textColor w-100  text-left">Gender</div>
          <v-radio-group
            v-model="user.gender"
            style="margin-bottom: -23px!important;"
            row
            class="ma-0"
          >
            <v-radio color="primary" label="Male" value="male"></v-radio>
            <v-radio color="primary" label="Female" value="female"></v-radio>
            <v-radio color="primary" label="Non-binary" value="non_binary"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-flex>

      <v-flex xs12 lg6>
        <v-text-field
          required
          color="#749DBF"
          class="textFeald"
          solo
          label="Driving School Name"
          placeholder="Driving School Name"
          v-model="user.clubName"
          disabled
        ></v-text-field>
      </v-flex>
      <v-flex xs12 lg6>
        <v-text-field
          solo
          name="Email"
          label="Email"
          :rules="emailRules"
          v-model="user.email"
          class="input-group--focused"
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12 lg6>
        <v-text-field
          required
          color="#749DBF"
          class="textFeald"
          type="password"
          solo
          label="Password"
          :rules="passwordRule"
          placeholder="Password"
          v-model="user.password"
        ></v-text-field>
      </v-flex>
      <v-flex md12 sm12 xs12 lg6 class="">
        <div class="f-15 w-100 text-xs-left textColor font-weight-bold">Select Package & Pay</div>
        <v-select
          solo
          :items="packages"
          item-text="name"
          item-value="id"
          v-model="selectedPackage"
          class="input-group--focused"
          label="Package name & Pay"
        ></v-select>
      </v-flex>
      <v-flex md12 sm12 xs12 lg6 class="">
        <div class="f-15 w-100 text-xs-left textColor font-weight-bold">Select Teacher</div>
        <v-select
          solo
          :items="teachers"
          item-text="name"
          item-value="id"
          v-model="selectedTeacher"
          class="input-group--focused"
          label="Teacher Name"
        ></v-select>
      </v-flex>
      <v-flex lg12 xs12>
        <v-flex lg3 xs6 sm4>
          <div class="f-15 text-xs-left textColor w-100 font-weight-bold text-xs-left">Upload Profile Picture</div>
          <input
            type="file"
            style="display:none"
            ref="ImgInput"
            accept="image/*"
            @change="onImgPicked"
          >
          <v-layout>
            <v-flex>
              <div class="w-100">
                <v-btn
                  class="card-r left"
                  outline
                  @click="onPickImg"
                >Upload</v-btn>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="br-2 pa-3 " v-if="this.user.profileImgPreview[0]">
              <div class="w-100 text-xs-right">
                <v-btn icon color="grey lighten-2"><v-icon>close</v-icon></v-btn>
              </div>
              <v-img
                :src="this.user.profileImgPreview[0]"
                :lazy-src="n"
                v-if="this.user.profileImgPreview[0]"
                class="grey lighten-2 h-150"
              >
                <v-layout
                  slot="placeholder"
                  fill-height
                  align-center
                  justify-center
                  ma-0
                >
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </v-img>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
      <v-flex lg12 xs12 lg4 sm12>
        <v-progress-circular
          indeterminate
          v-if=loading
          color="primary"
        ></v-progress-circular>
        <v-alert
          :value="true"
          color="success"
          icon="check_circle"
          v-if="alert.type=='success'"
          outline
        >
          {{alert.msg}}
        </v-alert>
        <v-alert
          :value="true"
          color="error"
          icon="warning"
          v-if="alert.type=='warning'"
          outline
        >
          {{alert.msg}}
        </v-alert>

      </v-flex>
      <v-flex lg12 xs12 sm12 class="text-xs-right">
        <v-btn
          class="card-r no-shadow text-white"
          color="primary darken-2"
          @click="CreateUser"
        >Save</v-btn>
      </v-flex>

      <!--<span class="f-30"> Insert text editor here </span>-->
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable */
import Datepiker from "@/components/pages/Datepicker";
import { mapState, dispatch } from "vuex";
import DateDropdown from 'vue-date-dropdown';
import VueDawa from "vue-dawa";
import api from "@/utils/backend-api.js"
export default {
  name: "AddNewStudentWidget",
  data: () => ({
    tab: null,
    newUserAddr: {
      oneLineAddress: ""
    },
    user: {
      firstName: "",
      lastName: "",
      phone: "",
      dob: "",
      address: {
        oneLineAddress: ""
      },
      gender: "",
      clubName: "",
      email: "",
      password: "",
      termAccept: false,
      profileImage:'',
      profileImgPreview:''
    },
    teacherClasses: {},
    counter: 0,
    seen: true,
    show: true,
    // yourValue: '',
    date: null,
    birthday: false,
    type: ["Student", "Teacher"],
    gender: ["male", "female","non-binary"],
    timeslot: [
      "07:00 am",
      "08:00 am",
      "09:00 am",
      "10:00 am",
      "11:00 am",
      "12:00 pm",
      "01:00 pm",
      "02:00 pm",
      "03:00 pm",
      "04:00 pm",
      "05:00 pm",
      "06:00 pm"
    ],
    workMin: [
      "60 min",
      "120 min",
      "180 min",
      "240 min",
      "300 min",
      "360 min",
      "420 min",
      "480 min"
    ],
    breakmin: ["15 min", "30 min", "45 min", "60 min"],
    requiredRule: [v => !!v || "This field is required"],
    emailRules: [
				v => !!v || "E-mail is required",
				v =>
					/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
					"E-mail must be valid"
      ],
    passwordRule: [
				v => !!v || "Password is required",
				v => (v && v.length > 6) || "Password must be grater than 8 characters & includes lower case, upper case & special characters"
      ],
    packages:[],
    teachers:[],
    selectedPackage:'',
    selectedTeacher:'',
    alert:{
      type:'',
      msg:''
    },
    loading:false,
    menu:null,

  }),
  watch: {},
  created() {
    this.user.clubName=Store.state.user.club_name
    Store.dispatch("Teachers/getAllTeachers")
    Store.dispatch('Packages/getAllPackages').then(res=>{
        setTimeout(() => {
          var packages=Store.state.Packages.adminpackages
          for(var x=0;x<packages.length;x++){
            var value={
              id:packages[x].id,
              name:packages[x].name+' ($ '+packages[x].cost+')'+' ('+packages[x].hours+' hours)'
            }
            this.packages.push(value)
          }
          var TeachersData=Store.state.Teachers.Teachers.Teachers
          for(var x=0;x<TeachersData.length;x++){
            var value1={
              id:TeachersData[x].id,
              name:TeachersData[x].name
            }
            this.teachers.push(value1)
          }
        }, 2500);

    })
    Store.dispatch("Teachers/getAllTeachers")

  },
  updated: () => {},
  methods: {
    onPickImg(){
        this.$refs.ImgInput.click();

    },
    onImgPicked(){
        this.user.profileImgPreview=[]
        const files = event.target.files
        this.user.profileImage=files[0]
        const fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
        fileReader.addEventListener("load", () => {
          this.user.profileImgPreview.push(fileReader.result)
        });
    },
    CreateUser() {
      this.loading=true
      this.alert.type=""
      if(this.loading==true){
        var Student = {
          name: this.user.firstName+' '+this.user.lastName,
          email: this.user.email,
          phone: this.user.phone,
          dob: (this.user.dob).substring(6,11)+'-'+(this.user.dob).substring(3,5)+'-'+(this.user.dob).substring(0,2),
          address: this.newUserAddr.oneLineAddress,
          city: this.newUserAddr.city,
          state: this.newUserAddr.state,
          zip: this.newUserAddr.zipCode,
          gender: this.user.gender,
          role: 'student',
          password: this.user.password,
          package_id:this.selectedPackage,
          teacher_id:this.selectedTeacher,
          club_id:Store.state.user.club_id,
          image:this.user.profileImage
        };
        var formData=new FormData()
        formData.append("name",Student.name)
        formData.append("email",Student.email)
        formData.append("phone",Student.phone)
        formData.append("dob",Student.dob)
        formData.append("address",Student.address)
        formData.append("city",Student.city)
        formData.append("state",Student.state)
        formData.append("zipCode",Student.zip)
        formData.append("gender",Student.gender)
        formData.append("role",Student.role)
        formData.append("password",Student.password)
        formData.append("package_id",Student.package_id)
        formData.append("teacher_id",Student.teacher_id)
        formData.append("club_id",Student.club_id)
        formData.append("image",Student.image)
        this.loading=true
          api.postData('admin/student/signup',formData)
          .then((res) => {
            console.log(res)
            if(res.status==201){
              this.loading=false
              this.alert.type="success"
              this.alert.msg="Student successfully created & Assign Teacher in student profile"
              setTimeout(() => {
                this.$router.push('/students')
              }, 1000);
            }else{
              this.loading=false
              this.alert.type="warning"
              this.alert.msg="Check your details and try again"
            }
          }).catch((error) => {
            this.loading=false
            this.alert.type="warning"
            this.alert.msg="Check your details and try again"
          })

      }else{
        this.loading=false
        this.alert.type="warning"
        this.alert.msg="Accept the Terms and Policies to continue"
      }
    },
    selectItem(payload, objectName) {
      this.$set(this, objectName, this.translateData(payload));
      // this.newUser.user.address = this.translateData(payload);
    },
    translateData(address) {
      if (!address || !address.data) {
        return;
      }
      return {
        id: address.data.id,
        street: address.data.vejnavn,
        streetNumber: address.data.husnr,
        floor: address.data.etage,
        door: address.data.dør,
        zipCode: address.data.postnr,
        city: address.data.postnrnavn,
        oneLineAddress: address.tekst
      };
    }
  },
  components: {
    VueDawa,
    Datepiker,
    DateDropdown
  }
};
</script>

<style>
  /*.v-dialog:not(.v-dialog--fullscreen){*/
    /*max-height: 500px!important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/pages/WidgetComponents/AddNewStudent.vue